import React, {useState, useEffect, Fragment} from 'react';
import flatstore from 'flatstore';
import parse from 'html-react-parser';
import axios from 'axios';
import { currentLang, apiURL, breedURL } from '../../../utils/functions';
import { isNil } from 'lodash';
import { useTranslation } from 'react-i18next';
import Image from '../Image';

const BreedsOverview = ({items}) => {
    //const [data, setData] = useState(null);
    const { t } = useTranslation();
    //console.log(animalId);
    

    /*useEffect(() => {
        breeds_overview_data = null;
        let url = apiURL()+"/breeds/animal/"+animalId;
        if(isNil(data)){
            try{
                axios.get(url, {}).then(function(response){
                    setData(response.data);
                });
            }catch(err){
                console.log(err);
            }
        }
    }, [])
    */

    return (
        <div className="container">
        <div className="row">
            {items && items.map((item, index)=>{
                //var url = "/"+currentLang()+"/"+t("menu.breeds")+"/"+item.slug;
                var url = breedURL(item.slug);
                return (
                    <div key={index} className="col-xs-12 col-md-6 col-lg-4">
                        <div className="list__item">
                            <div className="list__body">
                                <div className="list__image">
                                    <a className="read-more" href={url}>
                                        <Image src={item.image_url} alt={item.title} />
                                    </a>
                                </div>
                                <div className="list__description">
                                    <div>
                                        <h3 className="title">
                                            <a className="text--white" href={url}>{item.title}</a>
                                        </h3>
                                    </div>
                                    <a className="read-more" href={url}>{t('breeds.readmore')}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            })}
        </div>
        </div>
    )
}

export default BreedsOverview;